module.exports = __webpack_public_path__ + "static/media/7. Speaker Aria Putera Ismail.02cafe87.png";